import { setUser } from "@sentry/react";
import useAuthorization from "hooks/authorization/useAuthorization";
import { useEffect } from "react";
import { selectMyUser } from "store/account/selectors";
import posthog from "posthog-js";
import { useSelector } from "react-redux";
import UserRoles from "utilities/enumerations/UserRoles";

export default function useSetUserInfo() {
  const { user } = useSelector(selectMyUser);
  const { decodedToken } = useAuthorization();

  useEffect(() => {
    if (user?.uid) {
        // Set Sentry user info
        setUser({
          email: user.email,
          name: `${user.firstName} ${user.lastName}`,
          id: user.uid,
        });

        // Set PostHog user info
        posthog.identify(user.uid, {
          uid: user.uid,
          email: user.email,
          name: `${user.firstName} ${user.lastName}`,
          // NOTE: we only want to track impersonation if the impersonator is an ASP
          isImpersonatingAsASP: !!(
            decodedToken.impersonator_uid &&
            decodedToken.impersonator_role === UserRoles.ASP
          ),
        });
    }
  }, [user, decodedToken]);
}
